import styled from 'styled-components'
import { P as PKS } from 'konsys-ui'
import { DatePicker as DP, AutoComplete as AC } from 'antd'

export const Div = styled.div`
  position: absolute;
  top: -9px;
`

export const a = styled.div`
`

export const P = styled(PKS)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export const DatePicker = styled(DP)`
  width: 100%;
  margin: 16px 0 24px 0;
  >div {
    >input {
      height: 35px;
    }
  }
`

export const AutoComplete = styled(AC)`
  width: 100%;
  margin: 16px 0 8px 0;
  >div {
    .ant-input {
      height: 35px !important;
    }
  }
`
